import React from "react";

const BS5_Tables = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Tables Component</h2>
      <p>This is the BS5_Tables component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Tables;
